module.exports = __webpack_public_path__ + "img/daichao1.2418805d.png";